import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { formatApiError } from "../../lib/api";
import { LogoMark } from "../../components/Logo";
import { Seo } from "../../components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest-deep flex items-center justify-center px-4">
      <Seo title="Owner Login | Glow Green" description="Glow Green owner login." />
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl" data-testid="admin-login-card">
        <div className="flex items-center gap-3">
          <LogoMark className="w-10 h-10" />
          <div>
            <h1 className="font-display text-xl font-extrabold text-forest">Glow Green Admin</h1>
            <p className="text-xs text-slate-500">Sign in to manage your site</p>
          </div>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-semibold uppercase tracking-wider text-forest/70 mb-1.5">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-forest/15 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-leaf/50 focus:border-leaf"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-semibold uppercase tracking-wider text-forest/70 mb-1.5">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-forest/15 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-leaf/50 focus:border-leaf"
            />
          </div>
          {error && <p className="text-sm text-red-600" role="alert" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-forest px-6 py-3.5 font-display font-bold text-white hover:bg-forest-soft transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
